import { styled } from "styled-components";

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  vertical-align: middle;

  p,
  a {
    color: #2c2c2c;
  }
`;
export const SwitchWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 20px;
  background: grey;
  border-radius: 200px;
  flex-shrink: 0;
`;

export const HiddenInput = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  visibility: hidden;
`;
interface SwitchProps {
  checked: boolean;
}

export const SwitchLabel = styled.label<SwitchProps>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) => (props.checked ? "#77EC84" : "grey")};
  border-radius: 200px;
  transition: 0.4s;
`;

export const SwitchButton = styled.span<SwitchProps>`
  position: absolute;
  top: 3px;
  left: ${(props) => (props.checked ? "22px" : "3px")};
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  transition: 0.4s;
`;
